"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.controllerSuffix = 'Controller';
exports.DEFAULT_ACTION_NAME = 'index';
exports.LOG_CATEGORY_NAME = "node-mvc";
// export const DEFAULT_CONTROL_DIR = "modules"
